/* ============================================================
   sx-scripts.js — interacciones propias de la tienda (v2)
   Todo vanilla, sin librerías. Cada init comprueba si su
   elemento existe, así el mismo archivo vale para todas las
   páginas.
   ============================================================ */
(function () {
  'use strict';

  /* Este archivo lo incluyen TODAS las secciones, así que el navegador lo
     ejecuta una vez por sección. Sin este cerrojo se duplicarían los
     escuchadores y un clic en "Añadir al carrito" añadiría varias unidades. */
  if (window.sxCargado) return;
  window.sxCargado = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* evita volver a preparar un elemento que ya estaba listo
     (el editor de Shopify recarga secciones sueltas) */
  function nuevo(el, clave) {
    var k = 'sxInit' + clave;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  /* marca que hay JS: solo entonces el CSS esconde los elementos para animarlos */
  if (!REDUCED) document.documentElement.classList.add('sx-js');

  /* si algo fallara, a los 3 s se muestra todo igualmente */
  setTimeout(function () {
    document.querySelectorAll('.sx-reveal:not(.sx-in)').forEach(function (el) {
      el.classList.add('sx-in');
    });
  }, 3000);

  /* ---------- animaciones de entrada ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.sx-reveal:not(.sx-in)');
    if (!items.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('sx-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sx-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- barra superior rotativa ---------- */
  function initBar() {
    document.querySelectorAll('[data-sx-bar]').forEach(function (bar) {
      if (!nuevo(bar, 'Bar')) return;
      var items = bar.querySelectorAll('.sx-bar__item');
      if (items.length < 2) { if (items[0]) items[0].classList.add('sx-on'); return; }
      var i = 0;
      items[0].classList.add('sx-on');
      var ms = parseInt(bar.getAttribute('data-sx-bar'), 10) || 4000;
      if (REDUCED) return;
      setInterval(function () {
        items[i].classList.remove('sx-on');
        i = (i + 1) % items.length;
        items[i].classList.add('sx-on');
      }, ms);
    });
  }

  /* ---------- galería de producto ---------- */
  function initGallery() {
    document.querySelectorAll('[data-sx-gal]').forEach(function (gal) {
      if (!nuevo(gal, 'Gal')) return;
      var slides = gal.querySelectorAll('[data-sx-slide]');
      var thumbs = gal.querySelectorAll('[data-sx-thumb]');
      if (slides.length < 1) return;
      var cur = 0;

      function show(n) {
        if (n < 0) n = slides.length - 1;
        if (n >= slides.length) n = 0;
        slides[cur].classList.remove('sx-on');
        slides[n].classList.add('sx-on');
        if (thumbs[cur]) thumbs[cur].setAttribute('aria-current', 'false');
        if (thumbs[n]) {
          thumbs[n].setAttribute('aria-current', 'true');
          if (thumbs[n].scrollIntoView) {
            thumbs[n].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: REDUCED ? 'auto' : 'smooth' });
          }
        }
        cur = n;
      }

      thumbs.forEach(function (t, idx) {
        t.addEventListener('click', function () { show(idx); });
      });
      var prev = gal.querySelector('[data-sx-prev]');
      var next = gal.querySelector('[data-sx-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });

      /* deslizar con el dedo en móvil */
      var x0 = null;
      var main = gal.querySelector('[data-sx-galmain]');
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 42) show(dx < 0 ? cur + 1 : cur - 1);
          x0 = null;
        }, { passive: true });
      }
    });
  }

  /* ---------- selector de cantidad ---------- */
  function initQty() {
    document.querySelectorAll('[data-sx-qty]').forEach(function (box) {
      if (!nuevo(box, 'Qty')) return;
      var input = box.querySelector('input');
      if (!input) return;
      box.querySelectorAll('[data-sx-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-sx-step'), 10) || 1;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var max = parseInt(input.getAttribute('max'), 10) || 999;
          var v = (parseInt(input.value, 10) || min) + step;
          if (v < min) v = min;
          if (v > max) v = max;
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- variantes ---------- */
  function initVariants() {
    document.querySelectorAll('[data-sx-buy]').forEach(function (root) {
      if (!nuevo(root, 'Buy')) return;
      var dataEl = root.querySelector('[data-sx-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      if (!variants || !variants.length) return;

      var idInput = root.querySelector('[data-sx-varid]');
      var priceEl = root.querySelector('[data-sx-price]');
      var wasEl = root.querySelector('[data-sx-was]');
      var saveEl = root.querySelector('[data-sx-save]');
      var addBtn = root.querySelector('[data-sx-add]');
      var buyBtn = root.querySelector('[data-sx-buynow]');
      var stickyPrice = document.querySelector('[data-sx-sticky-price]');
      var groups = root.querySelectorAll('[data-sx-optgroup]');
      if (!groups.length) return;

      function money(cents) {
        var fmt = root.getAttribute('data-sx-money') || '{{amount_with_comma_separator}} €';
        var val = (cents / 100).toFixed(2).replace('.', ',');
        return fmt.replace(/\{\{\s*amount[^}]*\}\}/, val);
      }

      function selected() {
        return Array.prototype.map.call(groups, function (g) {
          var on = g.querySelector('[aria-pressed="true"]');
          return on ? on.getAttribute('data-sx-value') : null;
        });
      }

      function update() {
        var sel = selected();
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < sel.length; j++) {
            if (variants[i].options[j] !== sel[j]) { ok = false; break; }
          }
          if (ok) { match = variants[i]; break; }
        }
        if (!match) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-sx-unavailable') || 'No disponible'; }
          if (buyBtn) buyBtn.disabled = true;
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (stickyPrice) stickyPrice.textContent = money(match.price);
        if (wasEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            wasEl.textContent = money(match.compare_at_price);
            wasEl.hidden = false;
            if (saveEl) {
              saveEl.textContent = '-' + Math.round((1 - match.price / match.compare_at_price) * 100) + '%';
              saveEl.hidden = false;
            }
          } else {
            wasEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available
            ? (addBtn.getAttribute('data-sx-label') || 'Añadir al carrito')
            : (addBtn.getAttribute('data-sx-soldout') || 'Agotado');
        }
        if (buyBtn) buyBtn.disabled = !match.available;
      }

      groups.forEach(function (g) {
        g.querySelectorAll('[data-sx-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            g.querySelectorAll('[data-sx-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            update();
          });
        });
      });
      update();
    });
  }

  /* ---------- añadir al carrito (sin recargar) ---------- */
  function addToCart(form, btn) {
    var body = new FormData(form);

    /* Dawn puede estar configurado con aviso emergente (cart-notification)
       o con cajón lateral (cart-drawer). Soportamos los dos. */
    var aviso = document.querySelector('cart-notification');
    var cajon = document.querySelector('cart-drawer');
    var destino = aviso || cajon;
    var bubble = document.getElementById('cart-icon-bubble');

    var sections = [];
    if (aviso) {
      sections.push('cart-notification-product', 'cart-notification-button');
    } else if (cajon) {
      sections.push('cart-drawer');
    }
    if (bubble) sections.push('cart-icon-bubble');
    if (sections.length) body.append('sections', sections.join(','));
    body.append('sections_url', window.location.pathname);

    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-sx-adding') || 'Añadiendo…'; }

    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'error');
        if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-sx-added') || '✓ Añadido'; }

        var pintado = false;
        if (destino && res.sections && typeof destino.renderContents === 'function') {
          try {
            destino.renderContents(res);
            if (destino.classList) destino.classList.remove('is-empty');
            pintado = true;
          } catch (err) { pintado = false; }
        }

        /* el contador del icono del carrito, en cualquier caso */
        if (res.sections && res.sections['cart-icon-bubble'] && bubble) {
          try {
            var nuevo = new DOMParser()
              .parseFromString(res.sections['cart-icon-bubble'], 'text/html')
              .querySelector('#cart-icon-bubble');
            if (nuevo) { bubble.innerHTML = nuevo.innerHTML; pintado = true; }
          } catch (err) { /* sin contador, no pasa nada */ }
        }

        if (!pintado) {
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          return;
        }
        setTimeout(function () {
          if (btn) btn.textContent = original || btn.getAttribute('data-sx-label') || 'Añadir al carrito';
        }, 1800);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        form.submit();
      });
  }

  function initForms() {
    document.querySelectorAll('[data-sx-form]').forEach(function (form) {
      if (!nuevo(form, 'Form')) return;
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('[data-sx-add]');
        if (form.getAttribute('data-sx-direct') === 'true') return; /* deja pasar al checkout */
        e.preventDefault();
        addToCart(form, btn);
      });

      /* comprar ahora: mismo formulario, pero directo al pago */
      var buy = form.querySelector('[data-sx-buynow]');
      if (buy) {
        buy.addEventListener('click', function () {
          var ret = form.querySelector('[name="return_to"]');
          if (!ret) {
            ret = document.createElement('input');
            ret.type = 'hidden';
            ret.name = 'return_to';
            form.appendChild(ret);
          }
          ret.value = '/checkout';
          form.setAttribute('data-sx-direct', 'true');
        });
      }
    });

    /* tarjetas de producto de la portada */
    document.querySelectorAll('[data-sx-cardform]').forEach(function (form) {
      if (!nuevo(form, 'Card')) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(form, form.querySelector('[data-sx-add]'));
      });
    });
  }

  /* ---------- barra de compra fija en móvil ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sx-sticky]');
    if (!bar || !nuevo(bar, 'Sticky')) return;
    var anchor = document.querySelector('[data-sx-sticky-anchor]');
    if (!anchor) { bar.classList.add('sx-on'); return; }

    /* Se muestra cuando el botón principal de compra ya ha quedado por
       encima de la pantalla. Con escucha de scroll directa: funciona en
       todos los navegadores y no depende de observadores. */
    /* deja hueco al final de la página para que la barra fija
       no tape el pie ni el último botón */
    function ajustarHueco() {
      if (window.matchMedia('(max-width: 989px)').matches) {
        document.body.style.paddingBottom = (bar.offsetHeight || 70) + 'px';
      } else {
        document.body.style.paddingBottom = '';
      }
    }
    ajustarHueco();
    window.addEventListener('resize', ajustarHueco, { passive: true });

    var ultima = 0;
    function revisar() {
      var caja = anchor.getBoundingClientRect();
      bar.classList.toggle('sx-on', caja.bottom < 0);
    }
    function alHacerScroll() {
      var ahora = Date.now();
      if (ahora - ultima < 80) return;
      ultima = ahora;
      revisar();
    }
    window.addEventListener('scroll', alHacerScroll, { passive: true });
    window.addEventListener('resize', alHacerScroll, { passive: true });
    revisar();

    var go = bar.querySelector('[data-sx-sticky-cta]');
    if (go) {
      go.addEventListener('click', function (e) {
        var form = document.querySelector('[data-sx-form]');
        if (!form) return;
        e.preventDefault();
        addToCart(form, bar.querySelector('[data-sx-add]'));
      });
    }
  }

  /* ---------- acordeón de preguntas ---------- */
  function initFaq() {
    document.querySelectorAll('[data-sx-faq]').forEach(function (list) {
      if (!nuevo(list, 'Faq')) return;
      var single = list.getAttribute('data-sx-faq') === 'single';
      list.querySelectorAll('[data-sx-faqq]').forEach(function (btn) {
        var item = btn.closest('.sx-faq__i');
        var panel = item.querySelector('.sx-faq__a');
        btn.addEventListener('click', function () {
          var open = item.classList.contains('sx-open');
          if (single) {
            list.querySelectorAll('.sx-faq__i.sx-open').forEach(function (o) {
              if (o === item) return;
              o.classList.remove('sx-open');
              o.querySelector('.sx-faq__a').style.maxHeight = '0px';
              o.querySelector('[data-sx-faqq]').setAttribute('aria-expanded', 'false');
            });
          }
          item.classList.toggle('sx-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
          panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
        });
      });
    });
    window.addEventListener('resize', function () {
      document.querySelectorAll('.sx-faq__i.sx-open .sx-faq__a').forEach(function (p) {
        p.style.maxHeight = p.scrollHeight + 'px';
      });
    });
  }

  function boot() {
    initReveal();
    initBar();
    initGallery();
    initQty();
    initVariants();
    initForms();
    initSticky();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* el editor de Shopify recarga secciones sueltas: re-inicializa */
  document.addEventListener('shopify:section:load', boot);
})();
